import classNames from "classnames";
import { Block } from "components/ui/Block";
import { ErrorModal } from "components/ui/ErrorModal";
import { EntitleDarkLogo } from "components/ui/systemLogos/EntitleDarkLogo";
import useErrorModalState from "hooks/useErrorModalState";

import { GoogleLoginButton } from "../LoginButtons/GoogleLoginButton";
import { MicrosoftLoginButton } from "../LoginButtons/MicrosoftLoginButton";
import { OktaLoginButton } from "../LoginButtons/OktaLoginButton";
import { useStyles } from "./styles";

const PAGE_STYLE = { backgroundImage: "url(\"/loginBackground\")", backgroundSize: "cover" };

export const LoginPromptPage: FC = ({ className }) => {
  const { errorModalClose, errorModalError, errorModalIsOpen } = useErrorModalState();
  const classes = useStyles();

  return (
    <div className={classNames(classes.loginPromptPage, className)} style={PAGE_STYLE}>
      <div className={classes.overlays}>
        <ErrorModal error={errorModalError} isOpen={errorModalIsOpen} onClose={errorModalClose} />
      </div>

      <div className={classes.loginWrapper}>
        <Block className={classes.loginBlock}>
          <div className={classes.entitleLogo}>
            <EntitleDarkLogo className={classes.logo} />
          </div>

          <div className={classes.buttons}>
            <GoogleLoginButton />
            <OktaLoginButton />
            <MicrosoftLoginButton />
          </div>
        </Block>
      </div>
    </div>
  );
};
